import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { projectsData } from './Projects';
// import ASLProjectPage from './projects/ASLProjectPage';
// import DONProjectPage from './projects/DONProjectPage';
import ProjectHeader from './ProjectHeader';
import CoT from './projects/CoT';
import RGC from './projects/rgc';

// Map project IDs to their custom components
const projectComponents = {
  'compression-of-thought': CoT,
  'fast-fitting-jaxley': RGC
  // Add more projects here as you create them
};

const ProjectPage = () => {
  const { id } = useParams();
  const location = useLocation();
  
  // Try to get project data from navigation state first
  let project = location.state?.project;
  
  // If no project data in state, find it in projectsData
  if (!project) {
    project = projectsData.find(p => p.id === id);
  }
  
  // If still no project found, show error
  if (!project) {
    return (
      <div className="project-page-error">
        <ProjectHeader 
          title="Project Not Found" 
          date={new Date().toISOString()} 
        />
        <div className="error-content">
          <p>The project "{id}" could not be found.</p>
          <a href="/projects">← Back to Projects</a>
        </div>
      </div>
    );
  }

  // Get the custom component for this project
  const CustomProjectComponent = projectComponents[id];
  
  // If there's a custom component, render it
  if (CustomProjectComponent) {
    return <CustomProjectComponent project={project} />;
  }
  
  // Otherwise, render a default project page
  return (
    <div className="default-project-page">
      <ProjectHeader 
        title={project.title}
        date={project.date}
        featured={project.featured}
      />
      
      <div className="project-content">
        <section className="hero-section">
          <h2>{project.summary}</h2>
          <p>{project.description}</p>
        </section>

        

        {project.links && Object.keys(project.links).length > 0 && (
          <section className="links-section">
            <h3>Project Links</h3>
            <div className="project-links">
              {project.links.github && (
                <a href={project.links.github} target="_blank" rel="noopener noreferrer">
                  GitHub
                </a>
              )}
              {project.links.live && (
                <a href={project.links.live} target="_blank" rel="noopener noreferrer">
                  Live Site
                </a>
              )}
              {project.links.demo && (
                <a href={project.links.demo} target="_blank" rel="noopener noreferrer">
                  Demo
                </a>
              )}
            </div>
          </section>
        )}

        <section className="default-message">
          <p><em>This project doesn't have a custom page yet. Add one by creating a component and adding it to the projectComponents mapping.</em></p>
        </section>
      </div>
    </div>
  );
};

export default ProjectPage;